import { createSlice } from "@reduxjs/toolkit"
import type { RootState } from "../../app/store"
import { ValueList } from "@smartx/mikro-vt-client-api"

interface ValueListsState {
  saveDate: string
  valueLists: Array<ValueList>
}

const initialState: ValueListsState = {
  saveDate: "",
  valueLists: [],
}

export const valueListsSlice = createSlice({
  name: "valueLists",
  initialState,
  reducers: {
    setValueLists: (state, action) => {
      state.saveDate = action.payload.saveDate
      state.valueLists = action.payload.valueLists
    },
  },
})

export const { setValueLists } = valueListsSlice.actions
export const getValueLists = (state: RootState) => state.valueLists
export default valueListsSlice.reducer
